<template>
  <div>
    <div class="marquee" ref="marquee">
      <span ref="marqueeText" :style="{ animationDuration: durationSec + 's', }">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Letreiro",
  props: {
    text: {
      type: String,
      default: "Este é um texto rolando da direita para a esquerda continuamente..."
    }
  },
  data() {
    return {
      durationSec: 10,
      speedPxPerSec: 80
    }
  },
  mounted() {
    this.updateDuration()
    window.addEventListener('resize', this.updateDuration)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDuration)
  },
  watch: {
    text() {
      this.updateDuration()
    }
  },
  methods: {
    updateDuration() {
      this.$nextTick(() => {
        const container = this.$refs.marquee
        const text = this.$refs.marqueeText
        if (!container || !text) return
        const distance = text.offsetWidth + container.offsetWidth
        if (!distance) return
        this.durationSec = (distance / this.speedPxPerSec) / 3
      })
    }
  }
}
</script>

<style scoped>

.marquee {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: black;
  color: white;
  white-space: nowrap;
  box-sizing: border-box;
  border: 1px white solid;
  font-size: 36px;
}

.marquee span {
  display: inline-block;
  padding-left: 100%;
  animation: scroll linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}
</style>
